export const GetMembersColumns = (t) => [
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: ' ',
    dataIndex: 'status',
    key: 'status',
    width: '100px',
  },
  {
    title: t('labels.role'),
    dataIndex: 'role',
    key: 'role',
    width: '180px',
  },
  {
    title: t('labels.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: ' ',
    dataIndex: 'actions',
    key: 'actions',
    width: '60px',
  },
];